<template>
  <div class="app-body">
    <div style="font-size: 22px;color: #409EFF;cursor: pointer" @click="$router.push('/erp-store-log-manager')" >该功能已迁移至库存管理-库存记录,点击前往</div>
  </div>
</template>

<script>
/**
 * 收货记录列表
 */
import StoreLogTable from '@/views/modules/erp/common/store-log-table.vue'
import ProductReceiptImportDialog from '@/views/modules/erp/receipt/ProductReceiptImportDialog.vue'
import FileLink from '@/components/FileLink.vue'

export default {
  name: 'receive-manager',
  components: { FileLink, StoreLogTable, ProductReceiptImportDialog },
  data () {
    return {}
  },
  activated () {

  },
  watch: {},
  methods: {

    exportParams () {
      if (!this.$refs.table) {
        return {}
      }
      return this.$refs.table.dataForm
    },
    showProductReceiptImportDialog () {
      this.$refs.ProductReceiptImportDialog.init()
    }
  }
}
</script>

<style scoped>

</style>
